import { configure } from 'mobx';

configure({
  useProxies: 'always',
  enforceActions: 'always',
  computedRequiresReaction: true,
  disableErrorBoundaries: false,
});
